import React, { Component } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Alert from "react-s-alert";

import BasicTabs from "../../component/general/Tabs";
import EntityTable from "../../component/EntityTable";
import { MERCHANDISER_MAIN_PAGE } from "../../config/lang";
import Absence from "../merchandiser/Absence";
import Edit from "../merchandiser/Edit";
import Route from "../merchandiser/Route";
import View from "../merchandiser/View";

import { translate } from "../..//util/util";
import { call } from "../../util/action";
import { point, dateStart, dateEnd, networkTask, imageCount, tagCount } from "../../util/formatter";
import { getStore } from "../../util/redux/store";

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: "VIEW",
      new: false,
      changedItem: false,

      item: {
        date_joined: new Date(),
        date_deactivated: new Date(),
        date_till_newbie: new Date(),
        password: "",
        password2: "",
        company: null,
      },
      errors: [],

      tasks: [],
      routes: [],
      visits: [],
    };
  }

  getMe = () => {
    const me = getStore().getState().me;
    return me;
  };

  submit = () => {
    let { item, changedItem } = this.state;
    let errors = [];
    const me = this.getMe();
    if (item.password !== item.password2) {
      errors["password"] = "Passwords should match.";
    }

    if (errors.length > 0) {
      this.setState({ errors: errors });
      return;
    }

    if (!changedItem) return;

    let itemCopy = Object.assign(item, {});
    delete itemCopy.photo;
    itemCopy.company = me && me.company ? me.company.id : null;

    call({ method: item && item.id ? "PATCH" : "POST", url: item && item.id ? "merchandisers/" + item.id + "/" : "merchandisers/", post: item }, r => {
      if (r && r.id) {
        Alert.success(translate(MERCHANDISER_MAIN_PAGE, "data_successfully_saved", me.language), { position: "bottom-right" });
      } else {
        Alert.warning("Error while saving item. Error: " + JSON.stringify(r), { position: "bottom-right" });
      }
    });
    this.setState({ changedItem: false });
  };

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id !== "new") {
      this.load(id);
    } else {
      this.setState({ mode: "EDIT", new: true });
    }
  }

  load = id => {
    call({ method: "GET", url: "merchandisers/" + id + "/" }, r => {
      this.setState({ item: r });

      call({ method: "GET", url: "tasks?user=" + id }, r => {
        if (r.results) {
          this.setState({ tasks: r.results });
        }
      });

      call({ method: "GET", url: "visits?user=" + id }, r => {
        if (r.results) {
          this.setState({ visits: r.results });
        }
      });
    });
  };

  onChange = (property, value) => {
    let item = this.state.item;
    item[property] = value;
    this.setState({ item: item, changedItem: true });
  };

  toggleMode = () => {
    this.setState({ mode: this.state.mode == "EDIT" ? "VIEW" : "EDIT" });
  };

  handleBack = () => {
    this.props.history.replace("/merchandiser");
  };

  openTaskRow = row => {
    window.open(`/task/${row.id}`, "_blank");
  };

  openVisitRow = row => {
    window.open(`/visit/${row.id}`, "_blank");
  };

  render() {
    let { item } = this.state;
    const me = this.getMe();

    const tabLabels = [
      translate(MERCHANDISER_MAIN_PAGE, "edit_btn", me.language),
      translate(MERCHANDISER_MAIN_PAGE, "assignment", me.language),
      translate(MERCHANDISER_MAIN_PAGE, "visits", me.language),
      translate(MERCHANDISER_MAIN_PAGE, "presence", me.language),
    ];

    const tabContent = [
      <Route key="route-tab" user={item} />,
      <EntityTable key="task-tab" data={this.state.tasks} type="data" entity="merchandiser.task" openVisitFn={this.openTaskRow} rowClassName={() => "merch-clickable-row"}>
        <TableHeaderColumn dataField="id" isKey hidden></TableHeaderColumn>
        <TableHeaderColumn dataFormat={networkTask}>{translate(MERCHANDISER_MAIN_PAGE, "network_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataField="title">{translate(MERCHANDISER_MAIN_PAGE, "title_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={dateStart}>{translate(MERCHANDISER_MAIN_PAGE, "start_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={dateEnd}>{translate(MERCHANDISER_MAIN_PAGE, "end_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={imageCount}>{translate(MERCHANDISER_MAIN_PAGE, "number_of_images_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={tagCount}>{translate(MERCHANDISER_MAIN_PAGE, "number_of_tags_title", me.language)}</TableHeaderColumn>
      </EntityTable>,
      <EntityTable key="visit-tab" data={this.state.visits} type="data" entity="merchandiser.visit" openVisitFn={this.openVisitRow} rowClassName={() => "merch-clickable-row"}>
        <TableHeaderColumn dataField="id" isKey hidden></TableHeaderColumn>
        <TableHeaderColumn dataFormat={dateStart}>{translate(MERCHANDISER_MAIN_PAGE, "start_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={dateEnd}>{translate(MERCHANDISER_MAIN_PAGE, "completion_title", me.language)}</TableHeaderColumn>
        <TableHeaderColumn dataFormat={point}>{translate(MERCHANDISER_MAIN_PAGE, "point_title", me.language)}</TableHeaderColumn>
      </EntityTable>,
      <Absence key="absence-tab" user={item} />,
    ];

    return (
      <div className="container-fluid mp-page">
        <div className="mp-top-bar">
          <button className="mp-back-btn" onClick={this.handleBack}>
            <span className="material-symbols-outlined">arrow_back</span>
            {translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)}
          </button>
          {!this.state.new && (
            <button className="mp-toggle-btn" onClick={this.toggleMode}>
              <span className="material-symbols-outlined">{this.state.mode === "EDIT" ? "visibility" : "edit"}</span>
              {this.state.mode === "EDIT"
                ? translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)
                : translate(MERCHANDISER_MAIN_PAGE, "edit_btn", me.language)}
            </button>
          )}
        </div>

        <div className="mp-profile-card">
          {this.state.mode === "VIEW" ? (
            <View item={item} lang={me.language} />
          ) : (
            <Edit me={this.getMe()} item={item} isNew={this.state.new} errors={this.state.errors} submit={() => this.submit()} onChange={this.onChange} />
          )}
        </div>

        {!this.state.new && item && item.id && (
          <div className="mp-tabs-card">
            <BasicTabs className="tabs-list" labels={tabLabels} tabs={tabContent} />
          </div>
        )}
      </div>
    );
  }
}

export default Page;
